module.exports = __webpack_public_path__ + "static/media/cheerful-black-male-entrepreneur-talking-on-smartphone.4a8c8103.png";